import ISLXRepository from '../../2_domain/slx/iSLXRepository';
import { SLX } from '../../2_domain/slx/slx';
import Get from '../../lib/di/get';
import Connection from '../core/connection';
import { GET_SLX } from './SLXQuery';

class SLXRepository implements ISLXRepository {
  //LINK - id 49
  //NOTE - NA
  getSLX = async (): Promise<SLX> => {
    const connection = Get.find<Connection>('Connection');
    const client = connection.getClient();
    const res = await client.query({
      query: GET_SLX,
      fetchPolicy: 'cache-first',
    });
    return res.data['querySlx'];
  };
}

export default SLXRepository;
